<template>
  <div class="d-flex justify-content-end search-text-wrapper">
    <div class="d-flex align-self-center">
      <input
        class="searchable"
        :class="{'search-gone': !showQuerySearch, 'search-appear': showQuerySearch}"
        key="1"
        :placeholder="placeholder"
        ref="inputQuerySearch"
        type="text"
        name="searchable"
        id="searchable"
        :readonly="!showQuerySearch"
        @keyup="queryChanged($event)"
        :value="querySearch"
        required
      />
      <label v-if="showQuerySearch" class="reset-search" for="textbox">
        <i @click.prevent="resetSearch" class="fa fa-times" style="cursor: pointer;"></i>
      </label>
    </div>
    <va-popover v-if="showQueryButton" :message="searchTooltip.content" :placement="searchTooltip.placement">
      <span @click="toogleSearchVisibility"><i style="cursor: pointer; margin-top: 5px;" class="i-search"></i></span>&nbsp;
    </va-popover>
  </div>
</template>
<script>
export default {
  props: {
    querySearch: {
      type: String,
      required: true
    },
    debounceTimeout: {
      type: Number,
      required: false,
      default: 250,
      validator: (value) => {
        return Number.isInteger(value) && value >= 0
      }
    },
    placeholder: {
      type: String,
      required: false,
      default: function () {
        return this.$t('search.term')
      }
    },
    searchTooltip: {
      type: Object,
      required: false,
      default: function () {
        return {
          content: this.$t('search.tooltip_content'),
          placement: 'left'
        }
      }
    }
  },
  data () {
    return {
      showQuerySearch: false,
      showQueryButton: true,
      debounce: null
    }
  },
  methods: {
    queryChanged: function (event) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.$emit('update:querySearch', event.target.value)
      }, this.debounceTimeout)
    },
    resetSearch: function () {
      this.showQuerySearch = false
      setTimeout(() => {
        this.showQueryButton = true
        this.clearSearchInput()
      }, 500)
    },
    toogleSearchVisibility: function () {
      this.showQuerySearch = true
      this.showQueryButton = false
      if (this.showQuerySearch) {
        this.$nextTick(() => {
          this.$refs.inputQuerySearch.focus()
        })
      } else {
        this.clearSearchInput()
      }
    },
    clearSearchInput: function () {
      this.$emit('update:querySearch', '')
    }
  },
  watch: {
    querySearch: function (search) {
      if (search) {
        this.showQueryButton = false
        this.showQuerySearch = true
      }
    }
  }
}
</script>

<style lang="scss">
.search-text-wrapper {

  .reset-search {
    color: #6e6e6e;
    position: relative;
    margin-left: -15px;
    i {
      margin-left: -25px !important;
      margin-top: 0.4rem
    }
  }

  .searchable {
    background-color: transparent;
    -webkit-box-shadow: 0 0 4px 0 rgba(98, 106, 119, 0.25);
    box-shadow: 0 0 4px 0 rgba(98, 106, 119, 0.25);
    border-radius:20px;
    padding-left: 15px;
    border-style: solid;
    padding-right: 18px;
    margin-right: 15px;
    width: 225px;
    -webkit-transition: all .5s ease;
    -moz-transition: all .5s ease;
    transition: all .5s ease;
  }

  input.searchable{
    outline: none;
    border: none;
    height: 30px;
    &::placeholder {
      color: #D4D4D4 !important;
    }
  }

  .searchable::-webkit-outer-spin-button,
  .searchable::-webkit-inner-spin-button {
      -webkit-appearance: none;
  }

  .search-text-wrapper{
    min-height: 35px;
  }

  .v-leave { opacity: 1; }
  .v-leave-active { transition: opacity 250ms }
  .v-leave-to { opacity: 0; }
  .v-enter { opacity: 0; }
  .v-enter-active  { transition: opacity 250ms }
  .v-enter-to { opacity: 1; }

  .search-gone {
    padding: 0;
    cursor: default;
    visibility: none;
    opacity: 0;
    width: 0;
    animation-name: dissapearAnimation;
    animation-duration: 650ms;
  }

  @keyframes dissapearAnimation {
    0% {
      width: 225px;
    }
    100% {
      width: 0px;
      display: none;
    }
  }

  .animated {
    animation: spin 500ms infinite;
  }

  @keyframes spin {
    0% {transform: rotate(0deg);}
    100% {transform: rotate(180deg);}
  }

  .modal{
    overflow: auto;
  }
}
</style>
